import { LocalDataError } from '../types.js';
import { fiscalYear, fiscalYearStamp } from '../domain/time.js';
const PADDING = { TKT: 4, INV: 5 };
export class SequenceRepository {
    driver;
    context;
    constructor(driver, context) {
        this.driver = driver;
        this.context = context;
    }
    /** Build the pieces callers embed into an atomic batch. */
    plan(docType, timezone, at = new Date()) {
        const fy = fiscalYear(timezone, at);
        const stamp = fiscalYearStamp(fy);
        const prefix = docType === 'INV'
            ? `IN${stamp}-${this.context.deviceCode}-`
            : `TKT-${stamp}-${this.context.deviceCode}-`;
        return {
            docType,
            fiscalYear: fy,
            reserve: [
                {
                    sql: `UPDATE local_sequences SET next_value = next_value + 1
                WHERE doc_type = ? AND fiscal_year = ?`,
                    params: [docType, fy],
                },
                {
                    sql: `INSERT INTO local_sequences (doc_type, fiscal_year, next_value)
                SELECT ?, ?, 2 WHERE (SELECT changes()) = 0`,
                    params: [docType, fy],
                },
            ],
            numberExpr: `(? || printf('%0${PADDING[docType]}d',
        (SELECT next_value - 1 FROM local_sequences WHERE doc_type = ? AND fiscal_year = ?)))`,
            numberParams: [prefix, docType, fy],
        };
    }
    /** Allocate a number standalone (own transaction) and return it. */
    async next(docType, timezone, at = new Date()) {
        const plan = this.plan(docType, timezone, at);
        const results = await this.driver.batch([
            ...plan.reserve,
            {
                sql: `SELECT ${plan.numberExpr} AS number`,
                params: plan.numberParams,
            },
        ]);
        const number = results[plan.reserve.length]?.rows[0]?.number;
        if (typeof number !== 'string') {
            throw new LocalDataError('SEQUENCE_FAILED', `Could not allocate a ${docType} number`);
        }
        return number;
    }
    /** Current counter positions (diagnostics/tests). */
    async snapshot() {
        const rows = await this.driver.query({
            sql: 'SELECT doc_type, fiscal_year, next_value FROM local_sequences ORDER BY doc_type, fiscal_year',
        });
        return rows.map((r) => ({
            docType: String(r.doc_type),
            fiscalYear: String(r.fiscal_year),
            nextValue: Number(r.next_value),
        }));
    }
}
//# sourceMappingURL=sequences.js.map